export interface ICryptoSealsCharacterList {
  [key: string]: string
}
export const CryptoSealsCharacterList: ICryptoSealsCharacterList = {
  '0': 'Deathbringer',
  '1': 'Aberrant',
  '2': 'Verdant Witch',
  '3': 'Luminous Knight',
  '4': 'Eternal Watcher',
  '5': 'Undying Master',
  '6': 'Crawler'
}
